import { SxProps, Theme } from '@mui/material';

export const emptyFavoriteProductFrameSX = (variant: string): SxProps<Theme> => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	padding: { xs: '24px', sm: '48px' },
	border: variant === 'primary' ? { xs: '1px solid #E0E0E0', sm: 'none' } : '1px solid #E0E0E0',
	borderRadius: '8px',
	backgroundColor: variant === 'primary' ? '#F9F9F9' : '#FFFFFF',
});

export const emptyFavoriteProductIconSX: SxProps<Theme> = {
	fontSize: { xs: '40px', sm: '48px' },
	color: 'primary.main',
};

export const emptyFavoriteProductTitleSX: SxProps<Theme> = {
	fontSize: { xs: '20px', sm: '24px' },
	fontWeight: 'bold',
	marginBottom: '12px',
	textAlign: 'center',
	letterSpacing: '0.15px',
};

export const emptyFavoriteProductMessageSX: SxProps<Theme> = {
	fontSize: { xs: '14px', sm: '16px' },
	textAlign: 'center',
	letterSpacing: '0.15px',
};
